var r = {
  data: null,
  isLoading: !1,
  isLoaded: !1,
  error: null
}, e = (t, o) => ({
  setPatientInformationLoading: (a) => t((n) => ({ patientInformation: {
    ...n.patientInformation,
    isLoading: a
  } })),
  setPatientInformationData: (a) => t((n) => ({ patientInformation: {
    ...n.patientInformation,
    data: a,
    isLoaded: !0,
    isLoading: !1,
    error: null
  } })),
  setPatientInformationError: (a) => t((n) => ({ patientInformation: {
    ...n.patientInformation,
    isLoading: !1,
    error: a
  } })),
  clearPatientInformation: () => t(() => ({ patientInformation: r })),
  fetchPatientInformation: async (a) => {
    if (!o().patientInformation.isLoading) {
      t((n) => ({ patientInformation: {
        ...n.patientInformation,
        isLoading: !0
      } }));
      try {
        const n = await a({ method: "getPatientInformation" });
        return t((i) => ({ patientInformation: {
          ...i.patientInformation,
          data: n ?? null,
          isLoaded: !0,
          isLoading: !1,
          error: null
        } })), n;
      } catch (n) {
        t((i) => ({ patientInformation: {
          ...i.patientInformation,
          isLoading: !1,
          error: n instanceof Error ? n : new Error(String(n))
        } }));
        return;
      }
    }
  }
});
export {
  e as createPatientInformationActions,
  r as initialPatientInformationState
};

//# sourceMappingURL=patientInformation.action.js.map